import { render, staticRenderFns } from "./d-follow-button.vue?vue&type=template&id=bef43550&"
import script from "./d-follow-button.vue?vue&type=script&lang=js&"
export * from "./d-follow-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports